module.exports = __webpack_public_path__ + "static/media/greenCircleInfo.686b152c.svg";